import React from 'react'

class NotFound extends React.Component {
  render () {
    return (
      <div>
        <h1>404 Not Found</h1>
        <button onClick={this.props.history.goBack}>
          Go Back
        </button>
      </div>
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./src/components/not-found.js